export const getConfigurator = state => state.configurator;
